'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = {
  className: _react.PropTypes.string,
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  color: _react.PropTypes.string,
  strokeColor: _react.PropTypes.string,
  title: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/IconShape.js
// module id = 362
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16